'use strict';

function Message() {
  this.id = null;
  this.node = null;
  this.declaredClass = null;
  this.extends = [_Paths];

  this.presenter = null;
  this.msgIndex = null;
  this.failCallback = null;
  this._history = new History();
  this._analytics = new Analytics();

  this.init = function () {};

  this.initAllReady = function () {
    if (this.msgIndex === null) return;
    this._generateMessageContent();
    this._addEventHandler();
    this.updateMessageReadStatus();
  };

  this.updateMessageReadStatus = function () {
    if (this.presenter.getModelProperty('messages.messages[' + this.msgIndex + '].read_at')) {
      $(this.node).addClass('read-message');
    } else {
      $(this.node).removeClass('read-message');
    }
  };

  this._generateMessageContent = function () {
    this.node.innerHTML = '\n<div class="notification-message">\n  <div>\n    <div class="wrap--circle">\n        <svg viewBox="0 0 32 32" class="svg-icon"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-' + this._getIcon() + '"></use></svg>\n    </div>\n  </div>\n  <div>\n    <div class="notification-message__content">\n          ' + this.presenter.getModelProperty('messages.messages[' + this.msgIndex + '].message_content') + '\n    </div>\n    <div class="notification-message__time">\n        ' + this._getTime() + '\n    </div>\n  </div>\n</div>';
  };

  this._getIcon = function () {
    var iconName = 'dashboard3';
    switch (this.presenter.getModelProperty('messages.messages[' + this.msgIndex + '].product')) {
      case 'MogoMoney':
        iconName = 'money';
        break;
      case 'MogoAccount':
        iconName = 'account-settings';
        break;
      case 'CreditScore':
        iconName = 'creditscore';
        break;
      case 'MogoMortgage':
        iconName = 'mortgage';
        break;
      case 'MogoCrypto':
        iconName = 'bitcoin';
        break;
      case 'MogoSpend':
        iconName = 'card';
        break;
    }
    return iconName;
  };

  this._getTime = function () {
    var readTime = this.presenter.getModelProperty('messages.messages[' + this.msgIndex + '].created_at');
    var timeText = 'Now';
    var hours = moment().diff(readTime, 'hours');
    var days = moment().diff(readTime, 'days');
    var weeks = moment().diff(readTime, 'weeks');
    var months = moment().diff(readTime, 'months');
    var years = moment().diff(readTime, 'years');

    if (hours == 1) {
      timeText = '1 hour ago';
    } else if (hours > 1 && hours < 24) {
      timeText = hours + ' hours ago';
    } else if (days == 1) {
      timeText = '1 day ago';
    } else if (days > 1 && days < 7) {
      timeText = days + ' days ago';
    } else if (weeks == 1) {
      timeText = '1 week ago';
    } else if (weeks > 1 && weeks <= 4 && months == 0) {
      timeText = weeks + ' weeks ago';
    } else if (months == 1) {
      timeText = '1 month ago';
    } else if (months > 1 && months < 12) {
      timeText = months + ' months ago';
    } else if (years == 1) {
      timeText = '1 year ago';
    } else if (years > 1) {
      timeText = years + ' years ago';
    }
    return timeText;
  };

  this._addEventHandler = function () {
    var _this = this;

    $(this.node).on('click', function () {
      var analyticsId = 'Notification Centre-Item Navigation-' + _this.presenter.getModelProperty('messages.messages[' + _this.msgIndex + '].message_template_id') + ($(_this.node).hasClass('read-message') ? ' = Old' : ' = New') + '-Navigation-Component';
      _this._analytics.forcePushEvent('generic-member-navigation', {
        memberNavigation: [analyticsId]
      });
      if (_this.presenter.hasAction('messages.messages[' + _this.msgIndex + '].update_message')) {
        _this.presenter.performAction('messages.messages[' + _this.msgIndex + '].update_message', { seen: true, read: true }, function (data, response) {
          if (response === 200) {
            _this.presenter.setModelProperty('messages.messages[' + _this.msgIndex + '].seen_at', data.message.seen_at);
            _this.presenter.setModelProperty('messages.messages[' + _this.msgIndex + '].read_at', data.message.read_at);
            _this.updateMessageReadStatus();
            var targetUrl = _this.presenter.getModelProperty('messages.messages[' + _this.msgIndex + '].target');
            if (targetUrl) {
              if (targetUrl.indexOf('http') === 0) {
                window.location.href = targetUrl;
                return;
              }
              targetUrl = '/' + targetUrl;
              if (targetUrl.indexOf('/money/offers') > -1) {
                targetUrl = _this.paths.loans.offers;
              } else if (targetUrl.indexOf('/money') > -1) {
                targetUrl = _this.paths.loans.router;
              }
              if (targetUrl.indexOf('livechat') > -1) {
                if (window.LC_API.is_initialized && window.LC_API.open_chat_window) {
                  window.LC_API.open_chat_window();
                } else {
                  console.warn('no live chat instance was initialized');
                }
              } else {
                _this._history.goToUrl(targetUrl);
              }
            }
          } else {
            if (typeof _this.failCallback === 'function') {
              _this.failCallback(data, response, 'messages.messages[' + _this.msgIndex + '].update_message');
            }
            if (data && data.errors) {
              console.warn('perform update_message action failed: ', data.errors);
            }
          }
        });
      } else {
        console.warn('no update_message action found');
      }
    });
  };

  this.destroy = function () {};
}